import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagDJ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M22.826 27.174S7.337 7.319 7.322 7.322A24.922 24.922 0 0 1 25 0c13.807 0 25 11.193 25 25l-27.174 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M22.826 25S7.337 42.68 7.322 42.678A24.922 24.922 0 0 0 25 50c13.807 0 25-11.193 25-25H22.826Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.592 0 35.356L25 25 7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m10.118 18.479 1.619 4.982h5.238l-4.238 3.079 1.619 4.982-4.238-3.079-4.238 3.08 1.619-4.983-4.238-3.08h5.238l1.619-4.981Z"
}));
FlagDJ.displayName = 'FlagDJ';
export default withFlagWrapper(FlagDJ);
//# sourceMappingURL=index.js.map